import React from 'react';
import ReqDocHistory from './ReqDocHistory/ReqDocHistory';
import EntityHistory from './EntityHistory/EntityHistory';

export const historyModes = {
  reqDoc: 'reqDoc',
  all: 'all',
};

const ChangingHistory = ({
  mode = historyModes.reqDoc,
  visible,
  hide,
  getHistory,
  request,
  doc,
  title,
  onCancel,
  loading,
  items,
  modalProps = {},
}) => {
  const props =
    mode === historyModes.reqDoc
      ? { visible, hide, getHistory, request, doc }
      : { visible, title, onCancel, loading, items, modalProps };

  switch (mode) {
    case historyModes.reqDoc:
      return <ReqDocHistory {...props} />;

    case historyModes.all:
      return <EntityHistory {...props} />;

    default:
      return null;
  }
};

export default ChangingHistory;
